/*
 * Author: D. Lazar, Copyright 2012, Resistor Software Inc.
 */

 if(!LabelYourStuff) {
  var LabelYourStuff = {};
}

LabelYourStuff.utils = function() {
  
  var products = [];
  var queue = [];

  return {
  
    pushQueue : function(item) {
      queue.push(item);
    },

    popQueue : function() {
      return queue.pop();
    },

    getQueue : function () {
      return queue;
    },

    pushProduct : function(p) {
      products.push(p);
    },
    
    getProducts : function() {
      return products;
    },

    getProductById : function(id) {
      var p;
      $.each(products, function(i,v){
        if(v.id == id) {
          p = v
          return false;
        }
      });
      return p;
    }

  }

}();



jQuery(document).ready(function(){

jQuery("a[rel='lightbox']").colorbox({transition:"elastic"});

jQuery('.go-back a').click(function() {
javascript:history.back();
return false;
});

style = 'easeOutQuart';
jQuery('#product-collection li').hover(  
function() {  
//show
jQuery(this).children('div:first').stop(false,true).animate({bottom:1,left:1},{duration:500, easing: style});  
},  
   
function() {  
//hide
jQuery(this).children('div:first').stop(false,true).animate({bottom:-70, left:-191},{duration:500, easing: style});  
}  
);

jQuery('#search-input').click(function() {
jQuery(this).val('');
});

	jQuery('#sidebar-accordion').accordion({
	header: 'h3',
	selectedClass: 'selected',
	navigation: true,
	autoHeight: false,
	active: '.selected',
animated: 'bounceslide',
	alwaysOpen: false
	});


	jQuery("#sidebar-accordion ul.animated a").hover(function(){
		jQuery(this).stop().animate({ paddingLeft: "20px" }, 'fast');
	}, function(){
		jQuery(this).stop().animate({ paddingLeft: "10px" }, 'fast');
	});



});